import { render, staticRenderFns } from "./VR.vue?vue&type=template&id=f9504fcc"
import script from "./VR.vue?vue&type=script&lang=js"
export * from "./VR.vue?vue&type=script&lang=js"
import style0 from "./VR.vue?vue&type=style&index=0&id=f9504fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports